import { motion } from 'framer-motion'
import { Download, BookOpen } from 'lucide-react'

const ExampleWheels = ({ onLoadExample }) => {
  // 示例转盘配置
  const exampleWheels = [
    {
      name: '今天吃什么',
      title: '今天吃什么',
      subtitle: '解决选择困难症',
      items: [
        { id: 1, text: '中餐', color: '#ef4444', weight: 1 },
        { id: 2, text: '西餐', color: '#3b82f6', weight: 1 },
        { id: 3, text: '日料', color: '#22c55e', weight: 1 },
        { id: 4, text: '韩料', color: '#f97316', weight: 1 },
        { id: 5, text: '泰餐', color: '#8b5cf6', weight: 1 },
        { id: 6, text: '火锅', color: '#ec4899', weight: 1 }
      ]
    },
    {
      name: '周末活动',
      title: '周末活动',
      subtitle: '让周末更精彩',
      items: [
        { id: 1, text: '看电影', color: '#8b5cf6', weight: 1 },
        { id: 2, text: '去公园', color: '#22c55e', weight: 1 },
        { id: 3, text: '宅在家', color: '#f97316', weight: 1 },
        { id: 4, text: '逛街', color: '#ec4899', weight: 1 },
        { id: 5, text: '运动', color: '#06b6d4', weight: 1 },
        { id: 6, text: '聚餐', color: '#eab308', weight: 1 }
      ]
    },
    {
      name: '学习计划',
      title: '学习计划',
      subtitle: '提升自我每一天',
      items: [
        { id: 1, text: '编程', color: '#6366f1', weight: 1 },
        { id: 2, text: '阅读', color: '#ec4899', weight: 1 },
        { id: 3, text: '运动', color: '#06b6d4', weight: 1 },
        { id: 4, text: '绘画', color: '#84cc16', weight: 1 },
        { id: 5, text: '音乐', color: '#f59e0b', weight: 1 },
        { id: 6, text: '写作', color: '#8b5cf6', weight: 1 }
      ]
    },
    {
      name: '游戏选择',
      title: '游戏选择',
      subtitle: '放松娱乐时光',
      items: [
        { id: 1, text: '王者荣耀', color: '#eab308', weight: 1 },
        { id: 2, text: '原神', color: '#84cc16', weight: 1 },
        { id: 3, text: 'LOL', color: '#f59e0b', weight: 1 },
        { id: 4, text: '和平精英', color: '#ef4444', weight: 1 },
        { id: 5, text: '崩坏3', color: '#8b5cf6', weight: 1 },
        { id: 6, text: 'CSGO', color: '#6366f1', weight: 1 }
      ]
    }
  ]

  return (
    <div className="mt-8">
      <div className="flex items-center mb-4">
        <h4 className="text-lg font-semibold text-slate-900 flex items-center gap-2">
          <BookOpen className="w-5 h-5 text-theme-500" />
          示例转盘
        </h4>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {exampleWheels.map((example, index) => (
          <motion.button
            key={index}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onLoadExample(example)}
            className="p-4 bg-white rounded-lg border border-slate-200 hover:shadow transition-all duration-300 text-left"
          >
            <div className="flex items-center gap-2 mb-2">
              <Download className="w-4 h-4 text-theme-500" />
              <span className="font-medium text-slate-900">{example.title}</span>
            </div>
            <div className="text-xs text-slate-600 mb-3">{example.subtitle}</div>
            <div className="space-y-1">
              {example.items.slice(0, 3).map((item, itemIndex) => (
                <div
                  key={itemIndex}
                  className="flex items-center gap-2 text-sm"
                >
                  <div
                    className="w-3 h-3 rounded-full border border-slate-300 flex-shrink-0"
                    style={{ backgroundColor: item.color }}
                  />
                  <span className="text-slate-700 truncate">{item.text}</span>
                </div>
              ))}
              {example.items.length > 3 && (
                <div className="text-xs text-slate-500 text-center">
                  +{example.items.length - 3} 个选项
                </div>
              )}
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  )
}

export default ExampleWheels
